import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ClusterModel } from 'src/app/cluster/@shared/cluster.model';
import { fillSkeletonData } from 'src/app/@shared/app-helper';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cluster-preview',
  standalone: false,
  styleUrls: ['./cluster-preview.component.scss'],
  templateUrl: './cluster-preview.component.html',
})
export class ClusterPreviewComponent {
  @Input() public type: 'thumbnail' | 'avatar' | 'card';

  @Output() public openDetail: EventEmitter<ClusterModel> = new EventEmitter<ClusterModel>();

  public showSkeleton: boolean = true;
  public clusterIcon: string;

  // fill item with skeleton data
  // !!!IMPORTANT!!! always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<ClusterModel> = {
    title: fillSkeletonData('name'),
  };

  @Input()
  public get item(): ClusterModel {
    return this._item as ClusterModel;
  }

  public set item(item: ClusterModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<ClusterModel>;
    this.setIcon();

    this.showSkeleton = false;
  }

  private setIcon(): void {
    this.clusterIcon = this.item.isSmartCluster
      ? './assets/icons/folder-sync-outline.svg'
      : 'folder-outline';
  }
}
